import {
  exclusiveJobAction,
  jobActionList,
  withExclusiveJobAction,
} from '@classes/job-actions';

export function shouldStampNewBusinessDate(
  status?: string,
  todo?: string,
  existing?: unknown
): boolean {
  if (String(status || '') === 'QUOTE' || String(todo || '') === 'QUOTE') {
    return false;
  }
  return !existing;
}

export function stackStatusForType(type?: string): string {
  switch (type) {
    case 'A':
      return 'ORDER ACCESSORY';
    case 'F':
      return 'ORDER PART';
    case 'O':
    case 'N':
    default:
      return 'ORDER FRAME';
  }
}

export interface ApplySaveDestinationContext {
  isEnclosedFrame: boolean;
  stackStatus: string;
  awaitingStatus: string;
  currentStatus?: string;
  currentTodo?: string;
  currentRxStatus?: string;
  currentJobActions: string[];
  hasOrderLenses: boolean;
}

export function applySaveDestination(
  payload: any,
  destination: string,
  ctx: ApplySaveDestinationContext
): void {
  if (destination === 'AWAITING CUSTOMER APPROVAL' || destination === 'SEND ACKNOWLEDGEMENT') {
    payload.status = 'AWAITING CUSTOMER APPROVAL';
    payload.todo = destination === 'SEND ACKNOWLEDGEMENT' ? 'AWAITING RESPONSE' : 'ACK';
    return;
  }
  if (destination === 'SEND TO STACK') {
    payload.status = ctx.isEnclosedFrame ? ctx.stackStatus : 'TO ORDER';
    payload.todo = 'ORDER';
    if (payload.rxStatus === 'CALL FOR RX') {
      payload.rxStatus = '';
    }
    return;
  }
  if (destination === 'SAVE/HOLD') {
    payload.status = 'HOLD/RX';
    payload.todo = 'HOLD';
    payload.jobAction = 'HOLD / RX';
    payload.jobActions = withExclusiveJobAction(
      jobActionList(payload.jobAction, payload.jobActions),
      'HOLD / RX'
    );
    if (payload.rxStatus === 'CALL FOR RX') {
      payload.rxStatus = '';
    }
    return;
  }
  if (destination === 'HOLD') {
    payload.status = 'HOLD';
    payload.todo = 'HOLD';
    payload.jobAction = 'HOLD';
    payload.jobActions = withExclusiveJobAction(
      jobActionList(payload.jobAction, payload.jobActions),
      'HOLD'
    );
    return;
  }
  if (destination === 'SAVE/QUOTE') {
    payload.status = 'QUOTE';
    payload.todo = 'QUOTE';
    payload.jobAction = 'QUOTE';
    payload.jobActions = withExclusiveJobAction(
      jobActionList(payload.jobAction, payload.jobActions),
      'QUOTE'
    );
    payload.invoiceNumber = '';
    return;
  }
  if (destination === 'CALL / RX' || destination === 'CALL FOR RX') {
    payload.status = 'CALL FOR RX';
    payload.todo = 'CALL';
    payload.jobAction = 'CALL FOR RX';
    payload.jobActions = withExclusiveJobAction(
      jobActionList(payload.jobAction, payload.jobActions),
      'CALL FOR RX'
    );
    payload.rxStatus = 'CALL FOR RX';
    return;
  }
  if (destination === 'CALLED FOR RX') {
    payload.status = ctx.currentStatus;
    payload.todo = ctx.currentTodo;
    payload.rxStatus = ctx.currentRxStatus;
    return;
  }
  if (destination === 'RX RECEIVED') {
    payload.status = ctx.currentStatus;
    payload.todo = ctx.currentTodo;
    payload.rxStatus = '';
    payload.jobActions = ctx.currentJobActions;
    payload.jobAction = exclusiveJobAction(ctx.currentJobActions);
    return;
  }
  if (destination === 'INQUIRY') {
    payload.status = 'INQUIRY';
    payload.todo = 'INQUIRY';
    return;
  }
  if (destination === 'SENT FOR REPAIR') {
    payload.status = 'AWAITING REPAIR';
    payload.todo = 'REPAIR';
    return;
  }
  if (destination === 'TO REPAIR') {
    payload.status = 'TO REPAIR';
    payload.todo = 'REPAIR';
    payload.jobAction = 'REPAIR';
    payload.jobActions = withExclusiveJobAction(
      jobActionList(payload.jobAction, payload.jobActions),
      'REPAIR'
    );
    return;
  }
  if (destination === 'SHIPPED' || destination === 'ADD TO CART') {
    payload.status = 'DISPENSED';
    payload.todo = 'ADD TO CART';
    return;
  }
  if (
    destination === 'ORDERED FRAME' ||
    destination === 'ORDERED' ||
    destination === 'ORDERED ON APPROVAL' ||
    destination === 'ORDERED LENSES'
  ) {
    payload.status = ctx.awaitingStatus;
    if (destination === 'ORDERED LENSES' || ctx.hasOrderLenses) {
      payload.lensStatus = 'ORDERED';
    }
    return;
  }
  if (destination === 'RECEIVED LENSES') {
    payload.status = ctx.currentStatus;
    payload.lensStatus = 'RECEIVED';
    return;
  }
  if (destination === 'RECEIVED FRAME') {
    payload.status = ctx.currentStatus;
  }
}
